import {
  DealFunnelsResponse,
  DealsFilterParams,
  DealsResponse,
} from '@/shared/types/crm';
import { http } from '@/shared/api/http';

export const fetchDealFunnels = async (): Promise<DealFunnelsResponse> => {
  const response = await http.get('/crm/deal_funnels/list');
  return response.data;
};

export const fetchDeals = async (
  params?: DealsFilterParams
): Promise<DealsResponse> => {
  const response = await http.get('/crm/deals/list', { params });
  return response.data;
};

export const searchCompanies = async (
  search: string
): Promise<{ result: ANY[] }> => {
  const response = await http.get('/crm/companies', {
    params: { search },
  });
  return response.data;
};

// --- Контакты CRM (BE-9): поиск и создание ---
export interface CrmContact {
  id: number;
  name?: string;
  lastName?: string;
  phone?: string;
  email?: string;
}

export const searchContacts = async (
  search: string
): Promise<{ result: CrmContact[] }> => {
  const response = await http.get('/crm/contacts', { params: { search } });
  return response.data;
};

export const createContact = async (payload: {
  name?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  position?: string;
}): Promise<CrmContact> => {
  const response = await http.post('/crm/contacts', payload);
  return response.data;
};

export const createCompany = async (payload: {
  title: string;
  bin?: string;
  phone?: string;
  site?: string;
}): Promise<{ id: number; title?: string }> => {
  const response = await http.post('/crm/companies', payload);
  return response.data;
};
